__turbopack_context__.v({
  "card": "style-module-scss-module__n2qg5G__card",
  "mainText": "style-module-scss-module__n2qg5G__mainText",
  "media": "style-module-scss-module__n2qg5G__media",
  "mediaWrapper": "style-module-scss-module__n2qg5G__mediaWrapper",
  "meta": "style-module-scss-module__n2qg5G__meta",
  "overlay": "style-module-scss-module__n2qg5G__overlay",
  "subtitle": "style-module-scss-module__n2qg5G__subtitle",
  "textWrapper": "style-module-scss-module__n2qg5G__textWrapper",
  "withOverlay": "style-module-scss-module__n2qg5G__withOverlay",
});
